import { useState, useEffect } from "react";
import { Box, Grid, Container, Typography } from "@mui/material";
// components
import Page from "../components/Page";
import { AppTasks, AppNewUsers, AppBugReports, AppItemOrders, AppNewsUpdate, AppWeeklySales, AppOrderTimeline, AppCurrentVisits, AppWebsiteVisits, AppTrafficBySite, AppCurrentSubject, AppConversionRates } from "../components/_dashboard/app";
import { asyncRequest } from "src/services/network";
import { useNavigate } from "react-router";

// ----------------------------------------------------------------------

export default function SupplierDashboardApp() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    revenue: 0,
    orders: 0,
    products: 0,
    activeProducts: 0,
  });

  useEffect(() => {
    getStats();
  }, []);

  async function getStats() {
    const { data } = await asyncRequest({
      method: "get",
      path: "/stats",
    });

    setStats(data);
  }

  return (
    <Page title="控制台 | 首页">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">欢迎回来</Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <AppNewUsers title="今日营业额" num={stats.revenue || 0} onClick={() => {}} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppWeeklySales title="今日订单数" num={stats.orders || 0} onClick={() => {}} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppBugReports title="商品总数" num={stats.products || 0} onClick={() => {}} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppWeeklySales title="在售商品数" num={stats.activeProducts || 0} onClick={() => {}} />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
